import { Fragment } from 'react';
import { useIntl } from 'react-intl';
import { useTargetMessages } from 'src/hooks/useTargetMessages';
import { Movie } from '../types/movie';
import * as S from './styles';
import * as msgsData from './messages';

const { msgs, ...localesWithMessages } = msgsData;

type MovieCardProps = { className?: string; movie: Movie; number: number };

const streamingLinks = [
  {
    href: 'https://www.netflix.com/',
    message: msgs.netflix,
  },
  {
    href: 'https://www.amazon.com/Amazon-Video/b?ie=UTF8&node=2858778011',
    message: msgs.amazon,
  },
  {
    href: 'https://www.youtube.com/',
    message: msgs.youtube,
  },
  {
    href: 'https://tubitv.com/',
    message: msgs.tubi,
  },
];

export const MovieCard = ({
  className,
  movie: { benefits, genre, posterUrl, slug, synopsis, title },
  number,
}: MovieCardProps) => {
  const intl = useIntl();

  const targetMsgs = useTargetMessages(localesWithMessages);

  return (
    <S.MovieCard className={className} data-testid="movieCard" id={slug}>
      <S.Title>
        {number}. {title}
      </S.Title>

      <S.Paragraph>
        <S.Bold>{intl.formatMessage(msgs.genre)} </S.Bold>
        {genre}
      </S.Paragraph>

      <S.Paragraph>
        <S.Bold>{intl.formatMessage(msgs.checkForStreaming)} </S.Bold>

        <S.StreamingLinks>
          <S.Bold>
            {streamingLinks.map(({ href, message }, index) => (
              <Fragment key={href}>
                <S.Link href={href} target="_blank" rel="noopener noreferrer">
                  {intl.formatMessage(message)}
                </S.Link>
                {index + 1 !== streamingLinks.length && ' | '}
              </Fragment>
            ))}
          </S.Bold>
        </S.StreamingLinks>
      </S.Paragraph>

      {<S.Poster alt={title} src={posterUrl} />}

      <S.Paragraph>
        <S.Bold>{intl.formatMessage(msgs.synopsis)} </S.Bold>
        {synopsis}
      </S.Paragraph>

      <S.Paragraph>
        <S.Bold>{intl.formatMessage(targetMsgs.benefits)} </S.Bold>
      </S.Paragraph>

      <S.BenefitsList>
        {benefits.map(benefit => (
          <S.BenefitsListItem key={benefit}>{benefit}</S.BenefitsListItem>
        ))}
      </S.BenefitsList>
    </S.MovieCard>
  );
};
